<template>
  <div v-if="!loading" dir="rtl">
    <div class="d-flex flex-row">
      <button type="button" class="popup-close-btn f20-l30-m" @click="$emit('close')" aria-label="סגור">X</button>
      <h2 :id="selectCityPopupTitleId" class="f26-l30-m text-center flex-grow-1 heading-reset" v-html="data.header.text_html"></h2>
    </div>
    <HorizontalSplitter />
    <form class="formfield-round-border" :action="data.submit.url" ref="form" method="post">
      <div class="f16-l19 margin-top-20" v-html="data.body.text_html"></div>
      <FormAutoCompleteFieldComponent type="text" :name="data.body.fields[0].data_name" :datalist="data.body.fields[0].options" />
      <ButtonComponent :caption="data.submit.label" clazz="margin-top-20" @click="onSubmit()" @keyup.enter="onSubmit()"></ButtonComponent>
      <div class="justify-content-center text-center margin-top-20 f14-l18">
        <a class="red-link" href="#" @click="$emit('close')">{{data.buttons[0].label}}</a>
      </div>
    </form>
  </div>
</template>
<script>
import {fetch2, formSubmit} from '@/modules/configuration.js'
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import ButtonComponent from "@/components/form/ButtonComponent"
import FormAutoCompleteFieldComponent from "@/components/form/FormAutoCompleteFieldComponent"
import popupA11yChildMixin from '@/mixins/popupA11yChildMixin.js'

export default {
  mixins: [popupA11yChildMixin],
  components: {
    HorizontalSplitter,
    ButtonComponent,
    FormAutoCompleteFieldComponent
  },
  data() {
    return {
      loading: true,
      data: {},
      selectCityPopupTitleId: `select-city-popup-title-${this._.uid}`,
    }
  },
  methods: {
    async getData(url) {
      const data = await fetch2(this, url);
      if (Object.keys(data).length ===0) return ;

      this.data = data;
      this.loading = false;
      this.$nextTick(() => {
        this.registerPopupA11yMeta({ titleId: this.selectCityPopupTitleId, describedBy: null });
      });

    },
    async onSubmit() {
      let form = this.$refs.form;
      /*let response =*/ await formSubmit(this, form);
      await this.$nextTick();
      this.$emit("close");
      if (this.$route.path.indexOf('/d/') > 0 || this.$route.path.indexOf('/c/') === 0  /*dish/deal page / cook page*/) {
        this.emitter.emit('city-selected');
      } else {
        this.$router.go(0);
      }
    }
  },
  mounted() {
    this.getData("users/select_city");
  },

}
</script>
<style scoped>
.popup-close-btn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: #383838;
  line-height: inherit;
}
</style>